import axios from '@axios'

const PREFIX = '/consultas-configuraveis'

export default {
  getEmpresasConfiguradas(filtro) {
    return axios.post(`${PREFIX}/empresa`, filtro)
  },
  exportAsExcel(filtro) {
    return axios.post(`${PREFIX}/planilha-empresa`, filtro)
  },
  deleteExcel(fileName) {
    return axios.delete(`${PREFIX}/delete-planilha-empresa?fileName=${fileName}`)
  },
}
